<template>
  <ExhibitionContainer
    :trade-show-name="'TAPA EMEA 2026'"
    :activation-message="'Please scan your badge QR code'"
    has-badge-number-input
    :ble-id="label_id"
    :asset-id="asset_id"
    :token="t"
    :form-id="hubspotIds.formId"
    :portal-id="hubspotIds.portalId"
    :region="hubspotIds.region"
    :form-data-constructor="formDataConstructor"
    :asset-name-constructor="assetNameConstructor"
  >
    <template slot="banner">
      <Banner
        booth-number="First Floor"
      />
    </template>
  </ExhibitionContainer>
</template>
<script>
import ExhibitionContainer from '../../components/organisms/exhibitions/exhibition-container';
import Banner from '../../components/molecules/exhibitions/tapa-emea-2026-banner';

const emailRegex = /[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\.[a-zA-Z]{2,}/;
const nameRegex = /^FN:(.+)$/m;
const orgRegex = /^ORG:(.+)$/m;

export default {
  name: 'TapaEmea2026',
  components: {
    ExhibitionContainer,
    Banner,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    label_id: { type: String, required: true },
    // eslint-disable-next-line vue/prop-name-casing
    asset_id: { type: String, required: true },
    t: { type: String, default: '' },
  },
  computed: {
    hubspotIds() {
      return {
        formId: 'ec035ed3-c4bc-4306-845f-9d335c6de894',
        portalId: '27004227',
        region: 'eu1',
      };
    },
  },
  methods: {
    formDataConstructor(qrCodeData) {
      const match = qrCodeData.match(emailRegex);
      const email = match ? match[0] : null;
      console.log('Extracted email from QR code:', email);
      return [
        { name: 'email', value: email },
      ];
    },
    assetNameConstructor(formData) {
      const nameMatch = formData.badgeNumber.match(nameRegex);
      const orgMatch = formData.badgeNumber.match(orgRegex);
      const name = nameMatch ? nameMatch[1].trim() : 'Unknown';
      const org = orgMatch ? orgMatch[1].trim() : 'Unknown';
      return `${name} (${org})`;
    },
  },
};
</script>
